var exports = {
  "b": "Scroller.module__scrollerWrap___OWdsSz",
  "XG": "Scroller.module__scroller___OWdsSz",
  "xM": "Scroller.module__horizontal___OWdsSz",
  "RN": "Scroller.module__scrollbarReserve___OWdsSz",
  "Uv": "Scroller.module__scrollerChildren___OWdsSz",
  "cB": "Scroller.module__dragging___OWdsSz",
  "Hg": "Scroller.module__regular___OWdsSz",
};

module.exports = exports;
